import React, { useRef, useState, useEffect } from 'react';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { ModalHeader } from 'react-bootstrap';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';
import { useDispatch } from 'react-redux';
import cropBoxApi from '../../service/api/object/cropBox';

// Modal component
const Modal = ({ isOpen, onClose, children, buttonName = "Done" }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        padding: 20,
        background: '#fff',
        borderRadius: 5,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        position: 'relative',
        // minWidth: '50%',
        // minHeight: '50%'
      }}>
        {children}
        <PrimaryButton onClick={onClose} buttonName={buttonName} />
      </div>
    </div>
  );
};

// Video frame cropping component
const VideoFrameCropper = ({ videoRef, canvasRef, setCrop }) => {
  const dispatch = useDispatch();
  const [crop, setLocalCrop] = useState({ x: 100, y: 100, width: 400, height: 400 });
  const [isDragging, setIsDragging] = useState(false);
  const [draggingCorner, setDraggingCorner] = useState(null);
  const [isDetecting, setIsDetecting] = useState(false);

  // --- Auto detect the Object code start here ----------------
  // ---------- helper: center crop ----------
  const centerInitialCrop = (v) => {
    const vw = v.videoWidth || 0;
    const vh = v.videoHeight || 0;
    if (!vw || !vh) return;

    let w = Math.min(crop.width, Math.floor(vw * 0.9));
    let h = Math.min(crop.height, Math.floor(vh * 0.9));

    const aspect = crop.width / crop.height || 1;
    if (w / h > aspect) w = Math.round(h * aspect);
    else h = Math.round(w / aspect);

    const x = Math.round((vw - w) / 2);
    const y = Math.round((vh - h) / 2);

    const c = { x, y, width: w, height: h };
    setLocalCrop(c);
    setCrop(c);
  };

  // ---------- helper: clamp rect to video size ----------
  const clampToVideo = (bbox, vw, vh) => {
    let [x, y, w, h] = bbox;

    // slightly expand box to avoid being too tight
    const padding = 10;
    x = Math.max(0, x - padding);
    y = Math.max(0, y - padding);
    w = Math.min(vw - x, w + padding * 2);
    h = Math.min(vh - y, h + padding * 2);

    return {
      x: Math.round(x),
      y: Math.round(y),
      width: Math.round(w),
      height: Math.round(h),
    };
  };

  // ---------- helper: clamp rect to min size and video bounds ----------
  const DETECTION_TIMEOUT_MS = 25000; // 25 seconds
  const MIN_CROP_SIZE = 40; // tweak as you like
  const MAX_DETECT_WIDTH = 480;  // detection canvas max width
  const MAX_DETECT_HEIGHT = 480; // detection canvas max height


  const clampRectToSize = (rect, maxW, maxH) => {
    if (!maxW || !maxH) return rect;

    let { x, y, width, height } = rect;

    // Normalize negative sizes
    if (width < 0) {
      x = x + width;
      width = -width;
    }
    if (height < 0) {
      y = y + height;
      height = -height;
    }

    // Enforce minimum size
    width = Math.max(MIN_CROP_SIZE, width);
    height = Math.max(MIN_CROP_SIZE, height);

    // Clamp size
    if (width > maxW) width = maxW;
    if (height > maxH) height = maxH;

    // Clamp position so rect stays fully inside
    if (x < 0) x = 0;
    if (y < 0) y = 0;
    if (x + width > maxW) x = maxW - width;
    if (y + height > maxH) y = maxH - height;

    return { x, y, width, height };
  };


  // --------- New code for getting the Crop Box dimensions from the API starts ---------
  // Function to fetch crop box from API
  const getCropBoxFromAPI = async (image) => {
    setIsDetecting(true);
    // Assume you send the image to the API for crop box detection
    const formData = new FormData();
    formData.append('image', image); // Adjust this depending on your API's request format

    dispatch(
      cropBoxApi(
        formData,
        (response) => {
          console.log('Crop Box API response:', response?.data?.crop_box_dimensions);

          // Always making the center cropbox as per the Aarons feedback making this API logic false
          if (response.data && response.data.crop_box_dimensions && false) {
            const { x, y, w, h } = response.data.crop_box_dimensions;

            // Return the crop box with additional clamping to the canvas size
            const canvas = canvasRef.current;
            if (x || y || w || h) {
              const clampedCrop = clampRectToSize({ x, y, width: w, height: h }, canvas.width, canvas.height);
              setLocalCrop(clampedCrop);
              setCrop(clampedCrop);
            } else {
              centerInitialCrop(videoRef.current);
            }

          }

          centerInitialCrop(videoRef.current); 

          setIsDetecting(false);
        },
        (res) => {
          // console.log(res);
          setIsDetecting(false);
          centerInitialCrop(videoRef.current);

          // setResponceMsg(res.data.message);
          // setToasterType("error");

          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);
        }
      )
    );
  };

  // Function to call API and update crop
  const updateCropBox = async () => {
    setIsDetecting(true);
    const v = videoRef?.current;

    if (!v) return;

    const vw = v.videoWidth;
    const vh = v.videoHeight;

    // Fetch the image from the video (frame capture)
    const offCanvas = document.createElement('canvas');
    offCanvas.width = vw;
    offCanvas.height = vh;
    const offCtx = offCanvas.getContext('2d');
    offCtx.drawImage(v, 0, 0, vw, vh);

    // Get the image blob and call the API
    offCanvas.toBlob(async (blob) => {
      if (!blob) {
        console.error("Failed to convert canvas to blob");
        setIsDetecting(false);
        centerInitialCrop(v);
        return;
      }

      // Call the API to get crop box coordinates
      const cropBox = await getCropBoxFromAPI(blob);

      console.log('Received crop box from API:', cropBox);

      if (cropBox) {
        setLocalCrop(cropBox);
        setCrop(cropBox);
      } else {
        // Fallback to center crop if no valid response from API
        centerInitialCrop(v);
      }

      // setIsDetecting(false);
    }, 'image/png'); // specify the desired format, e.g., 'image/png'
  };

  // Timeout to cancel detection if it takes too long
  useEffect(() => {
    let cancelled = false;
    const timeoutId = setTimeout(() => {
      if (cancelled) return;
      cancelled = true;
      setIsDetecting(false);
      centerInitialCrop(videoRef.current); // Fallback to center crop after timeout
    }, DETECTION_TIMEOUT_MS);

    // Start the detection process
    updateCropBox();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [videoRef]);

  // --------- New code for getting the Crop Box dimensions from the API ends ---------

  // --- Auto detect the Object code ends here ----------------

  // ---------- drawing loop (unchanged) ----------
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const video = videoRef.current;

    const drawCircle = (ctx, x, y) => {
      ctx.beginPath();
      ctx.arc(x, y, 15, 0, 2 * Math.PI);
      ctx.fillStyle = 'white';
      ctx.fill();
      ctx.strokeStyle = 'black';
      ctx.stroke();
    };

    const drawCropArea = () => {
      if (!canvas || !ctx || !video) return;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0);

      ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(
        video,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        crop.x,
        crop.y,
        crop.width,
        crop.height
      );

      ctx.strokeStyle = 'white';
      ctx.lineWidth = 2;
      ctx.strokeRect(crop.x, crop.y, crop.width, crop.height);

      drawCircle(ctx, crop.x, crop.y);
      drawCircle(ctx, crop.x + crop.width, crop.y);
      drawCircle(ctx, crop.x, crop.y + crop.height);
      drawCircle(ctx, crop.x + crop.width, crop.y + crop.height);
    };

    const update = () => {
      drawCropArea();
      requestAnimationFrame(update);
    };

    update();
  }, [videoRef, canvasRef, crop]);

  // ---------- mouse handlers (same as your code, minus imports) ----------
  const getCanvasCoordinates = (event) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    return {
      x: (event.clientX - rect.left) * scaleX,
      y: (event.clientY - rect.top) * scaleY,
    };
  };

  const onMouseDown = (event) => {
    const { x, y } = getCanvasCoordinates(event);

    const corners = [
      { x: crop.x, y: crop.y, corner: 'tl' },
      { x: crop.x + crop.width, y: crop.y, corner: 'tr' },
      { x: crop.x, y: crop.y + crop.height, corner: 'bl' },
      { x: crop.x + crop.width, y: crop.y + crop.height, corner: 'br' },
    ];

    for (let corner of corners) {
      if (Math.abs(x - corner.x) < 10 && Math.abs(y - corner.y) < 10) {
        setDraggingCorner(corner.corner);
        setIsDragging(true);
        return;
      }
    }

    if (x > crop.x && x < crop.x + crop.width && y > crop.y && y < crop.y + crop.height) {
      setIsDragging(true);
      setDraggingCorner(null);
    }
  };

  const onMouseMove = (event) => {
    if (!isDragging) return;

    const { x, y } = getCanvasCoordinates(event);
    let newCrop = { ...crop };

    if (draggingCorner) {
      switch (draggingCorner) {
        case 'tl':
          newCrop.width += newCrop.x - x;
          newCrop.height += newCrop.y - y;
          newCrop.x = x;
          newCrop.y = y;
          break;
        case 'tr':
          newCrop.width = x - newCrop.x;
          newCrop.height += newCrop.y - y;
          newCrop.y = y;
          break;
        case 'bl':
          newCrop.width += newCrop.x - x;
          newCrop.height = y - newCrop.y;
          newCrop.x = x;
          break;
        case 'br':
          newCrop.width = x - newCrop.x;
          newCrop.height = y - newCrop.y;
          break;
        default:
          break;
      }
    } else {
      newCrop.x = Math.max(
        0,
        Math.min(x - newCrop.width / 2, canvasRef.current.width - newCrop.width)
      );
      newCrop.y = Math.max(
        0,
        Math.min(y - newCrop.height / 2, canvasRef.current.height - newCrop.height)
      );
    }

    setLocalCrop(newCrop);
    setCrop(newCrop);
  };

  const onMouseUp = () => {
    setIsDragging(false);
    setDraggingCorner(null);
  };

  return (
    <div>
      <div>
        <ResponceForAPI show={isDetecting} message={"One moment please."} />
      </div>
      <canvas
        ref={canvasRef}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        style={{ border: '1px solid black', cursor: 'pointer', maxWidth: '400px', minWidth: '350px' }}
      />
    </div>
  );
};

// Parent component
const VideoCropperModal = ({ videoRef, modalStatus, handleClose, buttonName = "Done", handleCloseOnly }) => {
  const canvasRef = useRef(null);
  const [cropData, setCropData] = useState({ x: 100, y: 100, width: 250, height: 250 });

  const handleSetCrop = (crop) => {
    setCropData(crop);
  };
  const base64ToBlob = (base64Data) => {
    const byteString = atob(base64Data.split(',')[1]);
    const mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };
  // Handle 'Done' click and return cropped image
  const handleDone = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const video = videoRef.current;

    // Create a new canvas to store the cropped image
    const croppedCanvas = document.createElement('canvas');
    croppedCanvas.width = cropData.width;
    croppedCanvas.height = cropData.height;

    const croppedCtx = croppedCanvas.getContext('2d');
    croppedCtx.drawImage(
      video,
      cropData.x, cropData.y, cropData.width, cropData.height,
      0, 0, cropData.width, cropData.height
    );

    // Get the base64 image data
    const croppedImageData = croppedCanvas.toDataURL('image/png');
    const croppedImageBlob = base64ToBlob(croppedImageData);
    console.log('Cropped Image Data:', croppedImageBlob);

    handleClose(croppedImageBlob); // Close the modal
  };

  return (
    <div>
      <Modal isOpen={modalStatus} onClose={handleDone} buttonName={buttonName}>
        <ModalHeader style={{ display: 'flex', justifyContent: 'flex-end', padding: '0px', paddingBottom: '10px' }}>
          <span onClick={handleCloseOnly} className='cursor-pointer' >
            <i className="bi bi-x-lg"></i>
          </span>
        </ModalHeader>
        <VideoFrameCropper videoRef={videoRef} canvasRef={canvasRef} setCrop={handleSetCrop} />
      </Modal>
    </div>
  );
};

export default VideoCropperModal;
